import { render, staticRenderFns } from "./Erro01View.vue?vue&type=template&id=d512a784&"
import script from "./Erro01View.vue?vue&type=script&lang=ts&"
export * from "./Erro01View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports